import { useEffect, useRef, useState } from 'react';

const useIsTextOverflowing = () => {
  const [isOverflowing, setIsOverflowing] = useState(false);

  const spanRef = useRef(null);

  useEffect(() => {
    const el = spanRef.current;

    if (!el) return;

    const checkOverflow = () =>
      setIsOverflowing(el.scrollWidth > el.clientWidth);

    checkOverflow();

    const resizeObserver = new ResizeObserver(checkOverflow);
    resizeObserver.observe(el);

    return () => resizeObserver.disconnect();
  }, []);

  return { isOverflowing, spanRef };
};

export default useIsTextOverflowing;
